import { useState } from 'react'
import { withStyles } from '@aura/components/styles'
import Divider from '@aura/components/divider'
import Grid from '@aura/components/grid'
import Link from '@aura/components/link'
import Typography from '@aura/components/typography'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './styles'


const Component = ({
    classes,
    isReadOnly
}) => {
    const { t: translate } = useTranslation()
    const [ isMobile ] = useState(window.innerWidth < 767)
    return (<Grid container className={classes.footerRoot} direction='column' justify='end'>
        <Grid className={classes.footerContainer}>
            {isMobile && <Grid container className={classes.linkContainerMobile} direction='column'>
                <Link className={classes.linkMainFirst} href={translate('footer.privacylink')} underline="none" target="_blank" disabled={isReadOnly} rel="noopener noreferrer">
                    {translate('privacy')}
                </Link>
                <Divider orientation="vertical" className={classes.footerDivider} />
                <Link className={classes.linkMain} href={translate('footer.legalDisclaimerLink')} underline="none" target="_blank" disabled={isReadOnly} rel="noopener noreferrer">
                    {translate('legalDisclaimer')}
                </Link>
                <Divider orientation="vertical" className={classes.footerDivider} />
                <Link className={classes.linkMain} href={translate('footer.accessibilityLink')} underline="none" target="_blank" disabled={isReadOnly} rel="noopener noreferrer">
                    {translate('accessibility')}
                </Link>
            </Grid>}
            <Grid className={classes.verbiageContainer}>
                <Typography className={classes.text}>{translate('footer.footerText')}</Typography>
            </Grid>
            <Grid className={classes.ciro} direction='column'>
                <div className={classes.ciroLogo}>
                    <img aria-labelledby="ciro logo" alt="ciro logo" src={translate('footer.ciroSrc')} />
                </div>
                <Link className={classes.link} href={translate('footer.cipfLink')} underline="none" target="_blank" rel="noopener noreferrer">
                    {translate('footer.cipf')}
                </Link>
            </Grid>
        </Grid>
    </Grid>)
}
Component.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(Component, styles)
